import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { priceRegex } from "../helper/regex";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { addavailability } from "../store/slices/roomType";

const AddRoomsAvailability = () => {
  const { id } = useParams();
  const [pricePerRoom, setpricePerRoom] = useState("");
  const [extraBedPrice, setextraBedPrice] = useState("");
  const [childrenwithBedPrice, setchildrenwithBedPrice] = useState("");
  const [breakfast, setBreakfast] = useState(false);
  const [lunchOrdinner, setlunchOrdinner] = useState(false);
  const [pricewithBreakfast, setpricewithBreakfast] = useState("");
  const [pricewithBreakfastandDinner, setpricewithBreakfastandDinner] =
    useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCheckboxChange = (e, checkboxType) => {
    const isChecked = e.target.checked;

    if (checkboxType === "breakfast") {
      setBreakfast(isChecked);

      if (!isChecked) {
        setpricewithBreakfast(""); // Clear price field if unchecked
      }
    }
    if (checkboxType === "lunchOrdinner") {
      setlunchOrdinner(isChecked);

      if (!isChecked) {
        setpricewithBreakfastandDinner(""); // Clear price field if unchecked
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    let sanitizedpricePerRoom = pricePerRoom;
    let sanitizedextraBedPrice = extraBedPrice;
    let sanitizedchildrenwithBedPrice = childrenwithBedPrice;
    let sanitizedpricewithBreakfast = pricewithBreakfast;
    let sanitizedpricewithBreakfastandDinner = pricewithBreakfastandDinner;

    switch (name) {
      case "pricePerRoom":
        sanitizedpricePerRoom = value.replace(/\D/g, "").slice(0, 5);
        setpricePerRoom(sanitizedpricePerRoom);
        validationErrors[name] =
          sanitizedpricePerRoom === "" ||
          !priceRegex.test(sanitizedpricePerRoom)
            ? "Please enter valid room price"
            : "";
        break;

      case "extraBedPrice":
        sanitizedextraBedPrice = value.replace(/\D/g, "").slice(0, 4);
        setextraBedPrice(sanitizedextraBedPrice);
        validationErrors[name] =
          sanitizedextraBedPrice === "" ||
          !priceRegex.test(sanitizedextraBedPrice)
            ? "Please enter valid value"
            : "";
        break;

      case "childrenwithBedPrice":
        sanitizedchildrenwithBedPrice = value.replace(/\D/g, "").slice(0, 4);
        setchildrenwithBedPrice(sanitizedchildrenwithBedPrice);
        validationErrors[name] =
          sanitizedchildrenwithBedPrice === "" ||
          !priceRegex.test(sanitizedchildrenwithBedPrice)
            ? "Please enter valid value"
            : "";
        break;

      case "startDate":
        setstartDate(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select start date" : "";
        break;

      case "endDate":
        setendDate(value);
        validationErrors[name] =
          value.trim() === ""
            ? "Please select start date"
              ? endDate < startDate
              : "End date must be after start date"
            : "";
        break;

      case "pricewithBreakfast":
        if (breakfast) {
          sanitizedpricewithBreakfast = value.replace(/\D/g, "").slice(0, 5);
          setpricewithBreakfast(sanitizedpricewithBreakfast);
          validationErrors[name] =
            sanitizedpricewithBreakfast === ""
              ? "Please enter price with breakfast"
              : "";
        } else {
          validationErrors[name] = "";
        }
        break;

      case "pricewithBreakfastandDinner":
        if (lunchOrdinner) {
          sanitizedpricewithBreakfastandDinner = value
            .replace(/\D/g, "")
            .slice(0, 5);
          setpricewithBreakfastandDinner(sanitizedpricewithBreakfastandDinner);
          validationErrors[name] =
            sanitizedpricewithBreakfastandDinner === "" ||
            !priceRegex.test(sanitizedpricewithBreakfastandDinner)
              ? "Please enter valid value"
              : "";
        } else {
          validationErrors[name] = "";
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const scrollToError = () => {
    const firstErrorField = document.querySelector(".is-invalid");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstErrorField.focus();
    }
  };

  const validateForm = () => {
    let newErrors = {};
    console.log("Validation Errors: ", newErrors);

    if (!pricePerRoom.trim()) {
      newErrors.pricePerRoom = "Please enter room price";
    } else if (!priceRegex.test(pricePerRoom)) {
      newErrors.pricePerRoom = "Please enter valid price";
    }

    if (!extraBedPrice.trim()) {
      newErrors.extraBedPrice = "Please enter extra bed price";
    } else if (!priceRegex.test(extraBedPrice)) {
      newErrors.extraBedPrice = "Please enter valid value";
    }

    if (!childrenwithBedPrice.trim()) {
      newErrors.childrenwithBedPrice = "Please enter child withbed price";
    } else if (!priceRegex.test(childrenwithBedPrice)) {
      newErrors.childrenwithBedPrice = "Please enter valid value";
    }

    if (breakfast && !pricewithBreakfast.trim()) {
      newErrors.pricewithBreakfast = "Please enter the price with breakfast";
    }

    if (lunchOrdinner && !pricewithBreakfastandDinner.trim()) {
      newErrors.pricewithBreakfastandDinner =
        "Please enter the price with breakfast and dinner";
    }

    if (!startDate.trim()) {
      newErrors.startDate = "Please select start date";
    }

    if (!endDate.trim()) {
      newErrors.endDate = "Please select end date";
    } else if (endDate < startDate) {
      newErrors.endDate = "End date must be after start date ";
    }

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    if (!isValid) {
      scrollToError();
    }
    return isValid;
  };

  const addNewRoom = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      setIsDisabled(false);
      return;
    }
    const roomId = id;

    const item = {
      pricePerRoom,
      childrenwithBedPrice,
      extraBedPrice,
      startDate,
      endDate,
      roomId,
      ...(breakfast && { breakfast: 1, pricewithBreakfast }),
      ...(lunchOrdinner && { lunchOrdinner: 1, pricewithBreakfastandDinner }),
    };

    try {
      await dispatch(addavailability(item)).unwrap();
      alert("Room added successfully!");
      navigate(-1);
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Room</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              onClick={cancel}
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Room
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Room</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addNewRoom}>
            <div className="row mb-40">
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Price <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="pricePerRoom"
                  value={pricePerRoom}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.pricePerRoom ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Room Price"
                />
                {errors.pricePerRoom && (
                  <div className="text-danger mt-2">{errors.pricePerRoom}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Extra Bed Price
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="extraBedPrice"
                  value={extraBedPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.extraBedPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Extra Bed Price"
                />
                {errors.extraBedPrice && (
                  <div className="text-danger mt-2">{errors.extraBedPrice}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Child With Bed Price
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="childrenwithBedPrice"
                  value={childrenwithBedPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.childrenwithBedPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Child With Bed Price"
                />
                {errors.childrenwithBedPrice && (
                  <div className="text-danger mt-2">
                    {errors.childrenwithBedPrice}
                  </div>
                )}
              </div>
              <div className="col-md-5" />
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Start Date
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="startDate"
                  value={startDate}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.startDate ? "is-invalid" : ""
                  }`}
                />
                {errors.startDate && (
                  <div className="text-danger mt-2">{errors.startDate}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  End Date
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="endDate"
                  value={endDate}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.endDate ? "is-invalid" : ""
                  }`}
                />
                {errors.endDate && (
                  <div className="text-danger mt-2">{errors.endDate}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <div className="form-switch mt-3 switch-purple d-flex align-items-center gap-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="switch4"
                    checked={breakfast}
                    onChange={(e) => handleCheckboxChange(e, "breakfast")}
                  />
                  <label
                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                    htmlFor="switch4"
                  >
                    &nbsp; Breakfast
                  </label>
                </div>
                {breakfast && (
                  <div className="mt-3">
                    <label className="form-label">Price With Breakfast</label>
                    <input
                      type="text"
                      value={pricewithBreakfast}
                      name="pricewithBreakfast"
                      onChange={handleChange}
                      placeholder="Enter Price With Breakfast"
                      className={`form-control ${
                        errors.pricewithBreakfast ? "is-invalid" : ""
                      }`}
                    />
                    {errors.pricewithBreakfast && (
                      <div className="text-danger mt-2">
                        {errors.pricewithBreakfast}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <div className="form-switch mt-3 switch-purple d-flex align-items-center gap-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="switch5"
                    checked={lunchOrdinner}
                    onChange={(e) => handleCheckboxChange(e, "lunchOrdinner")}
                  />
                  <label
                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                    htmlFor="switch5"
                  >
                    &nbsp; Lunch/Dinner
                  </label>
                </div>
                {lunchOrdinner && (
                  <div className="mt-3">
                    <label className="form-label">
                      Price With Lunch/Dinner
                    </label>
                    <input
                      type="text"
                      value={pricewithBreakfastandDinner}
                      name="pricewithBreakfastandDinner"
                      onChange={handleChange}
                      placeholder="Enter Price With Lunch/Dinner"
                      className={`form-control ${
                        errors.pricewithBreakfastandDinner ? "is-invalid" : ""
                      }`}
                    />
                    {errors.pricewithBreakfastandDinner && (
                      <div className="text-danger mt-2">
                        {errors.pricewithBreakfastandDinner}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddRoomsAvailability;
